export enum ActionKind {
  SelectTab = "SELECT_TAB",
  selectAccordion = "SELECT_ACCORDION",
}
export type State = { selectedTab: number; openedAccordion: number | null };
export type Action = {
  type: ActionKind;
  payload: number;
};
